var _ellipse, _path, _path2, _circle, _circle2, _rect, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.2287,
    cy: 77.792,
    rx: 31.7709,
    ry: 13.125,
    transform: "rotate(46.5755 61.2287 77.792)",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4995 58.125C37.4995 58.125 4.74087 126.266 4.06211 128.438C2.49933 133.438 6.56129 137.188 11.5621 135.938C13.6836 135.407 79.9995 102.5 79.9995 102.5",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.74 4.84915C123.177 4.00799 124.43 4.19105 124.609 5.12221L126.079 12.7885C126.158 13.1993 126.484 13.5176 126.897 13.5865L134.596 14.872C135.531 15.0281 135.744 16.2766 134.914 16.7342L128.077 20.5015C127.711 20.7034 127.509 21.1119 127.571 21.5255L128.728 29.2454C128.868 30.183 127.747 30.7715 127.055 30.1232L121.359 24.7852C121.054 24.4992 120.603 24.4333 120.229 24.6201L113.244 28.1058C112.396 28.5291 111.49 27.6444 111.892 26.7861L115.209 19.7197C115.387 19.3411 115.31 18.8919 115.017 18.5937L109.543 13.0281C108.879 12.3521 109.44 11.2168 110.381 11.3347L118.126 12.3054C118.541 12.3574 118.945 12.1456 119.138 11.7745L122.74 4.84915Z",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.125,
    cy: 93.75,
    r: 5.625,
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.625,
    cy: 18.125,
    r: 6.25,
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 121.414,
    y: 50.7886,
    width: 11.492,
    height: 11.492,
    rx: 3,
    transform: "rotate(45 121.414 50.7886)",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8145 129.063C22.8145 129.063 17.1868 117.911 28.1261 113.125C39.0655 108.34 43.7517 118.438 43.7517 118.438",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8125 9.0625C59.375 15.625 66.5625 32.1875 52.8125 47.5",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1875 87.1875C98.125 80.6251 115.312 71.8751 130.938 87.1874",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3751 63.4375C72.7085 58.0208 73.2493 48.8124 84.9993 44.0624C96.7493 39.3124 102.395 48.7499 103.749 54.0624C104.687 59.6875 100.312 60.3125 97.8118 57.1875C95.051 53.7365 87.1868 33.4375 104.999 23.4375",
    stroke: "#4BDACC",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParty);
export default __webpack_public_path__ + "static/media/party.7f2c915a8b438005ed5667c733311b08.svg";
export { ForwardRef as ReactComponent };